import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a8b77bda")
const _hoisted_1 = { class: "login-card" }
const _hoisted_2 = { class: "login-head" }
const _hoisted_3 = { class: "login-types" }
const _hoisted_4 = { class: "login-type-item current" }
const _hoisted_5 = { class: "login-type-name" }
const _hoisted_6 = { class: "login-type-name-is-active" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "login-type-underline login-type-underline-current" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "login-type-icon login-other-icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "login-type-name" }, [
  /*#__PURE__*/_createElementVNode("div", null, "其他方式"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-type-underline" })
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "login-type-name" }
const _hoisted_13 = { class: "login-bottom" }
const _hoisted_14 = {
  key: 0,
  class: "login-type-txt"
}
const _hoisted_15 = {
  key: 1,
  class: "ding-ding"
}
const _hoisted_16 = { class: "login-school" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "school-icon" }, null, -1)
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "login-bottom-btn" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "切换学校", -1)
const _hoisted_21 = {
  key: 1,
  class: "login-error-modal-mask"
}
const _hoisted_22 = { class: "login-error-modal" }
const _hoisted_23 = { class: "login-error-modal-container" }
const _hoisted_24 = { class: "first_p" }
const _hoisted_25 = { class: "second_p" }
const _hoisted_26 = { class: "login-error-modal-bottom" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_AuthorizedModal = _resolveComponent("AuthorizedModal")!
  const _component_personal_product_buy_modal = _resolveComponent("personal-product-buy-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(`login-type-icon login-type-icon-${_ctx.currentLoginType?.type}`)
            }, null, 2),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentLoginType?.name), 1),
              _hoisted_7
            ])
          ]),
          _createVNode(_component_el_popover, {
            placement: "right-start",
            width: 185,
            trigger: "click",
            "popper-class": "login-card-popover",
            disabled: _ctx.disable,
            visible: _ctx.otherLoginTypesVisible,
            "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.otherLoginTypesVisible = $event))
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["login-type-item other", _ctx.disable ? 'not-allow-click' : ''])
              }, _hoisted_10, 2)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherLoginTypes, (loginType) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["login-type-item", _ctx.disable ? 'not-allow-click' : '']),
                  key: loginType.type,
                  onClick: () => _ctx.handleChangeLoginType(loginType)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`login-type-icon login-type-icon-${loginType.type}`)
                  }, null, 2),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(loginType?.name), 1)
                ], 10, _hoisted_11))
              }), 128))
            ]),
            _: 1
          }, 8, ["disabled", "visible"])
        ])
      ]),
      _createElementVNode("div", {
        class: "login-container",
        style: _normalizeStyle({
        height:
          _ctx.currentLoginType?.type === _ctx.LoginTypeMap.ACCOUNT ||
          _ctx.currentLoginType?.type === _ctx.LoginTypeMap.ZDY
            ? 'calc(100% - 130px)'
            : 'calc(100% - 170px)',
      })
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentLoginComponent), {
          ref: "currentLoginComponentRef",
          disable: _ctx.disable,
          "onUpdate:disable": _cache[1] || (_cache[1] = ($event: any) => (_ctx.disable = $event)),
          handleLoginIn: _ctx.handleLogin,
          school: { schoolId: _ctx.lastDingSchool?.school_id },
          onHandleLoginIn: _ctx.handleLogin
        }, null, 8, ["disable", "handleLoginIn", "school", "onHandleLoginIn"]))
      ], 4),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.currentLoginType?.type === _ctx.LoginTypeMap.WE_CHAT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 微信扫码登录 "))
          : _createCommentVNode("", true),
        (_ctx.currentLoginType?.type === _ctx.LoginTypeMap.DING_DING)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.lastDingSchool?.school_name), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(["login-school-change-btn", _ctx.disable ? 'not-allow-click' : '']),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleGotoChooseSchool && _ctx.handleGotoChooseSchool(...args)))
                }, [
                  _createVNode(_component_el_icon, { class: "change-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Switch)
                    ]),
                    _: 1
                  }),
                  _hoisted_20
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.authorizeVisible)
      ? (_openBlock(), _createBlock(_component_AuthorizedModal, {
          key: 0,
          visible: _ctx.authorizeVisible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.authorizeVisible = $event)),
          type: _ctx.authorizeObj?.type,
          message: _ctx.authorizeObj?.message,
          changeSchoolBtnVisible: false
        }, null, 8, ["visible", "type", "message"]))
      : _createCommentVNode("", true),
    (_ctx.noRelateErrorObj?.type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.teacherName) + "老师，您好！", 1),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.noRelateErrorObj?.message), 1),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.noRelateErrorObj.type === 2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "btn-cancel",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeLoginErrorModal && _ctx.closeLoginErrorModal(...args)))
                    }, " 取消 "))
                  : _createCommentVNode("", true),
                (_ctx.noRelateErrorObj.type === 2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlePay && _ctx.handlePay(...args)))
                    }, " 续费 "))
                  : _createCommentVNode("", true),
                (![2, 3].includes(_ctx.noRelateErrorObj.type))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "btn",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeLoginErrorModal && _ctx.closeLoginErrorModal(...args)))
                    }, " 确定 "))
                  : _createCommentVNode("", true),
                (_ctx.noRelateErrorObj.type === 3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "btn",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeLoginErrorModal && _ctx.closeLoginErrorModal(...args)))
                    }, " 确定 "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_personal_product_buy_modal, {
      visible: _ctx.personalPayState.showBuyPage,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.personalPayState.showBuyPage = $event)),
      currentProduct: _ctx.personalPayState.currentProduct,
      onOnSuccess: _ctx.handlePaySuccess
    }, null, 8, ["visible", "currentProduct", "onOnSuccess"])
  ], 64))
}